import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { WindowContents } from '../../../shared/enums/windowContents';
import * as _ from 'lodash';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { OrderService } from '@app/cp/shared/services/order.service';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { OrderReceiveBus } from '@app/cp/shared/models/OrderReceiveBus';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderMessageInfo } from '@app/cp/shared/models/OrderMessageInfo';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { ReceivingDetailComponent } from './receiving-detail/receiving-detail.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { OrderReceiveDetailsBus } from '@app/cp/shared/models/OrderReceiveDetailBus';
import { GItem } from '@app/cp/shared/models/GItem';
import { _countGroupLabelsBeforeLegacyOption as _countGroupLabelsBeforeOption } from '@angular/material/legacy-core';
import { InventoryWeightedAverageDto } from '@app/cp/shared/models/InventoryWeightedAverageDto';
import { catchError, of } from 'rxjs';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'receiving',
    templateUrl: './receiving.component.html',
    styleUrls: ['./receiving.component.scss']
})
export class ReceivingComponent extends BaseEditComponent<OrderReceiveBus, OrderService, null, null> {
    compLoader: ICPLoader = this as any;
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.readOnly = false;
        this.saveMode = SaveMode.all;
    }
    @ViewChild('LineItems') protected lineItems: ReceivingDetailComponent;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();

    public showWindow: boolean = false;
    public contentTypes = WindowContents;
    public activeChildComp: number;
    orderId: any;
    ordersReceived: OrderReceiveBus[];
    ordersReceivedCBO: GItem[];
    info: OrderMessageInfo;
    isHistory: boolean = false;
    gridData: OrderDetailsBus[] = [];
    gridDataSaved: OrderDetailsBus[] = [];
    orderReceiveSaved: OrderReceiveBus;

    restoreSaved() {
        this.gridData = _.cloneDeep(this.gridDataSaved);
        this.data = _.cloneDeep(this.orderReceiveSaved);
        if (this.data) {
            this.data.orderReceiveId = null;
            this.setData(this.data);
        }
        this.isHistory = false;
        this.readOnly = false;
        this.setDirty();
    }
    addNewReceiving(e) {
        if (e) { }
        this.restoreSaved();
    }
    receivingHistoryChanged(e: GItem) {
        this.editForm.patchValue({
            orderReceiveId: e.value
        });
        this.getReceivingHistory(e.value);
    }
    //OrderReceiveId
    getReceivingHistory(id: any) {
        if (!this.isHistory) {
            this.gridDataSaved = _.cloneDeep(this.gridData);
            this.data.setFromForm(this.editForm.value);
            this.orderReceiveSaved = _.cloneDeep(this.data);
        }
        this.isHistory = true;
        this.svc_data.getOrderReceivedDetailsGrid(id).subscribe((info: BaseMessageInfo) => {
            this.gridData = info.primaryReturn;
            this.readOnly = true;
            let data: OrderReceiveBus = this.info.orderReceived.find(s => s.orderReceiveId === id);
            console.log("getOrderReceivedDetailsGrid: ", info, data);
            this.setData(data);
        });
    }

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'orderReceiveId': new UntypedFormControl(),
        'orderId': new UntypedFormControl(),
        'dateReceived': new UntypedFormControl(),
        'receivedById': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl()
    });
    setForm() {
        this.editForm.patchValue({
            orderReceiveId: this.data.orderReceiveId,
            orderId: this.data.orderId,
            dateReceived: this.data.dateReceived,
            receivedById: this.data.receivedById,
            insertUserId: this.data.insertUserId,
            insertDt: this.data.insertDt,
            updateUserId: this.data.updateUserId,
            updateDt: this.data.updateDt
        });
    }
    receiveAll() {
        this.lineItems.receiveAll();
    }
    createNew(busObj: OrderReceiveBus) {
        return new OrderReceiveBus(busObj);
    }
    customFormValidation() {
        return true;
    }
    getDataForCancel() {
        return this.createNew(null);
    }
    cancel() {

        this.closed.emit(false);
    }
    getData() {

        this.subs_data = this.svc_data.getReceivedForOrder(this.orderId).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                this.info = new OrderMessageInfo(info);
                //this.gridData = _.cloneDeep(this.info.orderDetailItems);
                //OrderDetailsBus
                this.gridData = [];
                if (CommonFunctions.hasArrayElementValue(info.orderDetailItems)) {
                    let arr = [];
                    for (let i = 0; i < info.orderDetailItems.length; i++) {
                        let busObj: OrderDetailsBus = new OrderDetailsBus(info.orderDetailItems[i]);
                        arr.push(busObj);
                    }
                    this.gridData = arr;

                }
                this.gridDataSaved = _.cloneDeep(this.gridData);
                if (CommonFunctions.hasArrayElementValue(info.orderReceived)) {
                    let arr = [];
                    for (let i = 0; i < this.info.orderReceived.length; i++) {
                        let item: GItem = { description: DateFunctions.formatDate_short(this.info.orderReceived[i].dateReceived), value: this.info.orderReceived[i].orderReceiveId, category: null, "reference": null };
                        arr.push(item);
                    }
                    this.ordersReceivedCBO = arr;
                }
                //this.gridData = info.orderDetailItems
                let busObj: OrderReceiveBus = new OrderReceiveBus(null); //info.primaryReturn);
                this.setNewObjDefaults(busObj);
                busObj.orderId = this.orderId;
                this.setData(busObj);
                //                this.lineItemsComp.setup(this.gridData);
                this.edit();
            }
        });

    }
    saveAll() {
        this.compLoader.cpLoader = true;
        let now: Date = DateFunctions.getDateNow();
        //this.li
        let busObj: OrderReceiveBus = new OrderReceiveBus(this.data);
        busObj.orderId = this.orderId;
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        let orderDetails: OrderDetailsBus[] = this.lineItems.getChanged();
        if (CommonFunctions.hasArrayElementValue(orderDetails)) {
            let arr = [];
            for (let i = 0; i < orderDetails.length; i++) {
                let busObjDet: OrderReceiveDetailsBus = new OrderReceiveDetailsBus(null);
                busObjDet.orderDetailId = orderDetails[i].orderDetailId;
                busObjDet.inventoryLocationId = orderDetails[i].inventoryLocationId;
                busObjDet.quantityReceived = orderDetails[i].quantityReceived;
                busObjDet.inventoryId = orderDetails[i].inventoryId;
                busObjDet.supplierId = orderDetails[i].supplierId;
                busObjDet.currentCost = orderDetails[i].price;
                busObjDet.updateCost = true;
                busObjDet.setCommon(this.globals.userId, now, this.globals.companyId, this.globals.personId);
                arr.push(busObjDet);
            }
            busObj.orderReceiveDetails = arr;
        }
        busObj.setBeforeSave();
        this.svc_data.saveOrderReceiving(busObj).subscribe((info: OrderMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess('Receive');
                this.closed.emit(true);
            }
            else {
                this.saveError(info.message);
            }
            this.compLoader.cpLoader = false;
        });
        if (this.compFeatureFlagSet.featureFlagSet["update-inventory-average-weighted-cost"]) {
            this.updateWeightedAverages(busObj);
        }

    }
    setup(data: any) {
        this.orderId = data;

        this.getData();
    }

    updateWeightedAverages(data: OrderReceiveBus): void {
        // Create payload array for weighted average updates
        const payload: InventoryWeightedAverageDto[] = data.orderReceiveDetails
            .filter(({ quantityReceived }) => quantityReceived != 0) // Filter out items with no received quantity
            .map(({ inventoryId, quantityReceived, currentCost }) => ({ // Map to InventoryWeightedAverageDto objects
                inventoryId,
                quantity: quantityReceived,
                cost: currentCost,
            }));

        // If payload is empty, no need to proceed
        if (payload.length === 0) {
            console.log('No items to update.');
            return;
        }

        // Call the service to update weighted averages and handle errors
        this.svc_data.updateWeightedAverages(payload).pipe(
            catchError(error => {
                console.error('Failed to update weighted averages:', error);
                return of(); // Return an empty observable or a default value if necessary
            })
        ).subscribe(() => {
            console.log('Weighted averages updated successfully.');
        });
    }

}
